<template>
  <div
    class="hidden h-96 w-1/2 flex-none flex-col divide-y divide-gray-200 overflow-y-auto sm:flex"
  >
    <div class="flex flex-col gap-3 py-4">
      <div class="flex flex-shrink-0 flex-row px-4">
        <div class="flex flex-1 flex-col">
          <h2
            class="cursor-pointer text-xl font-semibold capitalize text-gray-900 dark:text-white"
            @click="$emit('click-option', activeOption)"
          >
            <span>
              {{ activeOption.title }}
            </span>

            <span
              v-if="activeOption.type?.name"
              class="ml-2 inline-flex flex-row items-center gap-x-1 rounded px-2 text-[10px] lowercase"
              :class="[
                `bg-theme-${activeOption.type.bg_color} text-${activeOption.type.text_color}`
              ]"
            >
              <FontAwesomeIcon :icon="['fas', activeOption.type.icon]" />

              {{ activeOption.type.name }}
            </span>
          </h2>
          <h3
            v-if="activeOption.subtitle"
            class="text text-lg font-semibold text-gray-400"
          >
            {{ activeOption.subtitle }}
          </h3>
        </div>
        <div v-if="activeOption.thumbnail" class="flex-shrink-0">
          {{ activeOption.thumbnail }}
        </div>
      </div>
      <div class="flex flex-col gap-1.5">
        <template v-for="info in activeOption.extra">
          <div
            v-if="info.type === 'text' && info.value"
            class="flex flex-row px-4"
          >
            <div class="flex flex-1 flex-col">
              <span class="text-xs text-gray-700">{{ $t(info.label) }} </span>
              <span class="-mt-0.5 font-medium" v-html="info.value" />
            </div>
            <div
              v-if="info.links"
              class="flex flex-shrink-0 flex-row items-center"
            >
              <template v-for="link in info.links">
                <a
                  v-if="link.type === 'email'"
                  class="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-white"
                  :href="`mailto:${link.email}`"
                >
                  <FontAwesomeIcon
                    :icon="['fal', 'envelope']"
                  ></FontAwesomeIcon>
                </a>
                <a
                  v-if="link.type === 'external-link'"
                  class="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-white"
                  :href="link.url"
                  target="_blank"
                >
                  <FontAwesomeIcon
                    :icon="['fal', link.icon ?? 'external-link']"
                  />
                </a>
              </template>
            </div>
          </div>
          <div
            v-if="info.type === 'link' && info.value && info.link"
            class="flex cursor-pointer flex-row px-4 hover:bg-gray-100"
          >
            <a
              class="flex cursor-pointer items-center justify-center"
              :href="info.link.url"
            >
              <FontAwesomeIcon
                :icon="['fal', info.link.icon]"
                size="2xs"
                class="mr-1 mt-1 h-3 w-3 rounded-full border border-primary p-1 text-primary"
              />
              <div class="flex flex-1 flex-col">
                <span class="text-xs text-gray-700">{{ $t(info.label) }} </span>
                <span class="-mt-0.5 font-medium" v-html="info.value" />
              </div>
            </a>
          </div>
          <div
            v-else-if="info.type === 'image' && info.src"
            class="flex flex-col px-4 py-1"
          >
            <img :src="info.src" alt="" class="rounded-lg border p-1" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default defineComponent({
  name: 'CommandPalettePreview',
  components: { FontAwesomeIcon },
  props: {
    activeOption: {
      type: Object,
      required: true
    }
  },
  emits: ['click-option']
})
</script>
